const contact = document.querySelector("[data-js='contact']");
const contactPersonButton = document.querySelector("#m-contact-person-btn");
const contactPersonSubmit = document.querySelector("#contact-person-submit");
const contactPersonInfo = document.querySelector("#contactPersonInfo");
// const filterMapButton = document.querySelector("#m-f-map-btn");
// const filterSelectionReset = document.querySelector("#list-filter-selection-reset");
// let filterListItemSelection = document.querySelectorAll(".list-filter-selection-item");

// When Filter exists
if (contact) {
  (function () {
    "use strict";
    window.addEventListener(
      "load",
      function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName("needs-validation");
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
          form.addEventListener(
            "submit",
            function (event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              }
              form.classList.add("was-validated");
            },
            false
          );
        });
      },
      false
    );
  })();

  // filterMapButton.addEventListener("click", function () {
  // 	$("#m-f-map").modal("show");
  // });
}

if (contactPersonButton) {
  contactPersonButton.addEventListener("click", function () {
    $("#m-c-person").modal("show");
  });

  contactPersonSubmit.addEventListener("click", function () {
    $("input[name='contactPerson']:checked").each(function () {
      const selectedContact = this;

      const contactCounter = selectedContact.dataset.contact;

      const contactPersonInfo = document.getElementById(
        `contactPersonInfo-${contactCounter}`
      );
      if (contactPersonInfo) {
        document.querySelectorAll(".contactPersonInfo").forEach((info) => {
          info.classList.add("d-none");
        });

        contactPersonInfo.classList.remove("d-none");
        contactPersonButton.value = selectedContact.value;
      } else {
        console.error(
          "Keine Kontaktinfo für den ausgewählten Kontakt gefunden."
        );
      }
    });
  });
}
